<script setup></script>

<template>
  <div class="border-l-4 border-[#6A6AF4] bg-[#F5F5FE] p-6 md:p-8 xl:p-12">
    <h3 v-if="$slots.title" class="text-[#161616] text-[22px] font-bold mb-6">
      <slot name="title" />
    </h3>
    <div class="text-[3A3A3A] text-base">
      <slot />
    </div>
  </div>
</template>
